import { render, staticRenderFns } from "./Lender.vue?vue&type=template&id=62c9a54c&scoped=true&"
import script from "./Lender.vue?vue&type=script&lang=js&"
export * from "./Lender.vue?vue&type=script&lang=js&"
import style0 from "./Lender.vue?vue&type=style&index=0&id=62c9a54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9a54c",
  null
  
)

export default component.exports